import { render, staticRenderFns } from "./ReadonlyTable.vue?vue&type=template&id=0247c579&"
import script from "./ReadonlyTable.vue?vue&type=script&lang=js&"
export * from "./ReadonlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports